export default __webpack_public_path__ + "static/media/Overview_Product_Selection_Image.26b63954.png";